import { STATS } from "../lib/constants";

export const StatsBar = () => {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-[#0B2545] border-y border-[#C8A24A]/20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className={`reveal px-6 md:px-8 ${
                i !== 0 ? "md:border-l border-[#C8A24A]/25" : ""
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div
                className={`font-serif text-[#C8A24A] font-semibold leading-tight ${
                  s.compact ? "text-xl md:text-2xl" : "text-4xl md:text-5xl leading-none"
                }`}
              >
                {s.value}
              </div>
              <div className="mt-3 font-sans text-white text-sm md:text-base uppercase tracking-widest-2">
                {s.label}
              </div>
              {s.note && (
                <div className="mt-1 font-sans text-white/55 text-xs">
                  {s.note}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
